import { useContext } from "react"
import { AuthContext } from "./AuthContext"

export const useAuth = () => {
  const [loggedUser, signIn, signOut] = useContext(AuthContext)
  return {loggedUser, signIn, signOut}
}